import styled from '@emotion/styled';
import { Button } from 'ds/components/button';

export const DURATION_IN_SECONDS = 0.25;
export const DURATION_IN_MS = DURATION_IN_SECONDS * 1000;
export const BUTTON_HEIGHT = 48;
export const BUTTON_WIDTH = 48;
export const COMMON_TRANSITION = `${DURATION_IN_SECONDS}s ease-in-out`;

export const Wrapper = styled.div`
  position: relative;
  min-height: ${BUTTON_HEIGHT}px;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const WhatsAppAnimatedWrapper = styled.div<{
  isFormOpen?: boolean;
}>(({ theme, isFormOpen }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  minWidth: '48px',
  overflow: 'hidden',
  width: isFormOpen ? '48px' : '168px',
  marginRight: isFormOpen ? '8px' : '0',
  transformOrigin: 'left',
  transition: `
    max-width ${COMMON_TRANSITION},
    width ${COMMON_TRANSITION},
    marginLeft ${COMMON_TRANSITION},
    marginRight ${COMMON_TRANSITION}
  `,

  [theme.media.createCustomObjectMediaQuery('0px', '425px')]: {
    width: isFormOpen ? '48px' : '158px',
  },
}));

export const WhatsAppBtn = styled(Button)<{
  isFormOpen?: boolean;
}>`
  background: ${({ theme }) => theme.colors.brand.madlanGreen};
  &:disabled {
    background: ${({ theme }) => theme.colors.neutrals.grey6};
  }
  border-color: ${({ theme }) => theme.colors.brand.madlanGreen};
  color: ${({ theme }) => theme.colors.neutrals.white};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  > span {
    opacity: ${({ isFormOpen }) => (isFormOpen ? 0 : 1)};
    white-space: nowrap;
    margin-right: ${({ isFormOpen }) => (isFormOpen ? '0' : '8px')};
    width: ${({ isFormOpen }) => (isFormOpen ? '0' : 'auto')};
    transition:
      opacity ${COMMON_TRANSITION},
      width ${COMMON_TRANSITION};
    transition-delay: ${({ isFormOpen }) => (isFormOpen ? '0s' : `${DURATION_IN_SECONDS}s`)};
  }
  > svg {
    flex-shrink: 0;
  }
  > svg path {
    fill: ${({ theme }) => theme.colors.neutrals.white};
  }
`;

export const CollectNumberForm = styled.form(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  justifyContent: 'flex-start',
  flexGrow: 1,
  '> button': {
    width: 'auto',
    paddingLeft: theme.spacing(1),
  },
}));

export const CloseButton = styled(Button)(({ theme }) => ({
  background: 'transparent',
  border: 'none',
  padding: theme.spacing(1),
  'svg path': {
    fill: theme.colors.neutrals.grey3,
  },
}));

export const TermsWrap = styled.div(({ theme }) => ({
  padding: theme.spacing(2, 1, 0),
  position: 'absolute',
  left: '-64px',
  right: 0,
  top: '40px',
  whiteSpace: 'normal',
}));

export const ChildrenWrapper = styled.div(({ theme }) => ({
  position: 'absolute',
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    'a, button': {
      width: '168px !important',
    },
  },
  [theme.media.createCustomObjectMediaQuery('0px', '425px')]: {
    'a, button': {
      width: '150px !important',
    },
  },
}));
